import axios from "axios";

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const API_URL = `${API_BASE}/api/usuarios`;

export const obtenerUsuarios = (empresaId) => axios.get(API_URL, { params: { empresaId } });
export const obtenerUsuario = (id) => axios.get(`${API_URL}/${id}`);
export const crearUsuario = (usuario) => axios.post(API_URL, usuario);
export const actualizarUsuario = (id, usuario) => axios.put(`${API_URL}/${id}`, usuario);
export const eliminarUsuario = (id) => axios.delete(`${API_URL}/${id}`);
